export const calculateDesiredSteps = (
  minValue: number,
  maxValue: number,
  minDesiredTicks: number = 3,
  maxDesiredTicks: number = 5
) => {
  const dataRange = maxValue - minValue

  for (let steps = maxDesiredTicks; steps >= minDesiredTicks; steps--) {
    const interval = Math.round(dataRange / (steps - 1))

    if (Number.isInteger(interval) && interval !== 0) {
      return { interval, steps }
    }
  }

  return { interval: maxValue, steps: maxDesiredTicks }
}
